import React from 'react';
import migration from 'assets/images/migration.png';

function MigrationNotice() {
  const currentPath = window.location.pathname;
  const newDomain = process.env.REACT_APP_HOSTED_URL;

  const handleRedirect = () => {
    const mappedPath = mapOldRouteToNew(currentPath);
    window.location.href = `${newDomain}${mappedPath}`;
  };

  // Function to map old route to the new route
  const mapOldRouteToNew = path => {
    // Check if the path matches the old adventures edit route format
    if (path.startsWith('/adventures/') && path.endsWith('/edit')) {
      const adventureId = path.split('/adventures/')[1].split('/edit')[0];
      const newPath = `/adventures/edit/${adventureId}?step=basic-info`;

      return newPath;
    }

    // Handle the specific case for profile mapping
    if (path.startsWith('/admin/whoaguides/profile/')) {
      // Extract the old profile ID
      const whoaguideId = path.split('/admin/whoaguides/profile/')[1];
      return `/profile/${whoaguideId}`;
    }

    // Add specific route mappings here
    const routeMapping = {
      '/admin/whoaguides': '/whoa-guides',
      '/admin/whoaguides/profile': '/profile/',
      '/admin/whoaguides/add': '/whoa-guides/add',
      '/admin/users': '/players',
      '/admin/profile': '/profile',
      '/admin/profile/edit': '/profile/edit',
      '/admin/payments': '/payment',
      '/privacy-policy': '/privacy-policy',
      '/eula': '/user-agreement',
    };

    return routeMapping[path] || '';
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        minWidth: '100vw',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
        padding: '20px',
        paddingTop: '10px',
        boxSizing: 'border-box',
      }}
    >
      <img src={migration} alt="Migration" style={{ maxWidth: '100%', height: '400px', marginBottom: '30px' }} />

      <h3 style={{ fontSize: '1.5rem', marginBottom: '10px', color: '#333' }}>
        We have improved our platform for you!
      </h3>

      <p style={{ fontSize: '1rem', marginBottom: '20px', color: '#666', maxWidth: '600px' }}>
        {`We've upgraded our platform for a better experience. Please click the button below to visit our new site.`}
      </p>

      <button
        onClick={handleRedirect}
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          color: '#fff',
          backgroundColor: '#007bff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
        }}
      >
        Go to New Site
      </button>
    </div>
  );
}

export default MigrationNotice;
